import React from 'react'
import './contact.css'
// import Clients from './clients'
import Contactme from './contactme'

const Contact = () => {
  return (
    <section id="contactPage">
        {/* <Clients /> */}
        <Contactme />
    </section>
  )
}

export default Contact
